import { Box, useTheme } from "@carrotfertility/carotene-core"
import React from "react"

// Derived from Box rather than importing the (unexported) SxProps type.
type BoxSx = React.ComponentProps<typeof Box>["sx"]

export type SkeletonProps = {
  width?: number | string
  height?: number | string
  circular?: boolean
  sx?: BoxSx
}

export function Skeleton({ width, height, circular = false, sx }: SkeletonProps): JSX.Element {
  const theme = useTheme()
  return (
    <Box
      aria-hidden
      // Array form is MUI's supported sx merge (a caller sx may be a function/array); caller wins, last.
      sx={[
        {
          inlineSize: width,
          blockSize: height,
          flexShrink: 0,
          backgroundColor: theme.palette.background.hover,
          borderRadius: circular ? "50%" : theme.tokens.borderRadius.sm,
          "@keyframes carrotSkeletonPulse": {
            "0%": { opacity: 1 },
            "50%": { opacity: 0.4 },
            "100%": { opacity: 1 }
          },
          animation: "carrotSkeletonPulse 1.6s ease-in-out infinite",
          "@media (prefers-reduced-motion: reduce)": { animation: "none" }
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
      ]}
    />
  )
}
